import map from "lodash/map";
import orderBy from "lodash/orderBy";
import React, { useMemo } from "react";
import { Col, Row } from "react-grid-system";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";

import { getCurrentOrganization } from "../../../../../../selectors/organizationSelectors";
import FormContextTextField from "../../../../../forms/formik/FormContextInputs/FormContextTextField";

import SectionHeader from "../../../../JobCasts/view/Candidates/actions/modals/Hire/SectionHeader";
import FieldSection from "../FieldSection";

import TimesheetApproversField from "./TimesheetApproversField";
import AllocationsField from "./AllocationsField";
import FormContextDropdownSelect from "../../../../JobCasts/create/formContextInputs/FormContextDropdownSelect";

function CostCenterField() {
  const costCenters = useSelector((state) => state.costCenters.items);
  const options = useMemo(
    () => orderBy(
      map(costCenters, ({ attributes: { id, name } }) => ({
        label: name,
        value: id,
      })),
      ({ label }) => label.toLowerCase()
    ),
    [costCenters]
  );

  return (
    <FormContextDropdownSelect
      id="costCenterId"
      label="Cost Center"
      options={options}
      isMulti={false}
      isClearable={false}
    />
  );
}

function InvoiceMemoField() {
  return (
    <FormContextTextField id="invoiceMemo" label="Invoice Memo (optional)" />
  );
}

function determineSectionLabel(ukgWorkforceIntegrationEnabled, timesheetSubmissionParty) {
  if (ukgWorkforceIntegrationEnabled || timesheetSubmissionParty === "client") {
    return "Contract Managers";
  }
  return "Contract Managers";
}

function determineSectionDescription(ukgWorkforceIntegrationEnabled, timesheetSubmissionParty) {
  if (ukgWorkforceIntegrationEnabled) {
    return "The following people may receive reminder emails when this contract is close to ending and will be responsible for converting the worker through RecruitiFi if they are converted to full-time.";
  }
  return timesheetSubmissionParty === "client" ?
    "The following people may receive emails to submit timesheets for this worker, when the contract is close to ending, and will be responsible for converting the worker through RecruitiFi if they are converted to full-time." :
    "The following people may receive emails to approve timesheets for this worker and can access the hours worked.";
}

function BillingInformation() {
  const currentOrganization = useSelector(getCurrentOrganization);
  const { values: { timesheetSubmissionParty } } = useFormikContext();

  const sectionLabel = determineSectionLabel(currentOrganization.ukgWorkforceIntegrationEnabled, timesheetSubmissionParty);
  const sectionDescription = determineSectionDescription(currentOrganization.ukgWorkforceIntegrationEnabled, timesheetSubmissionParty);
  const showAllocations = currentOrganization.requirePoNumber;

  return (
    <>
      <SectionHeader title="Billing Information" />
      <FieldSection>
        <Row>
          <Col xs={12} md={4}>
            <CostCenterField />
          </Col>
          {!showAllocations && (
            <Col xs={12} md={4}>
              <InvoiceMemoField />
            </Col>
          )}
        </Row>
        {showAllocations && (
          <Row>
            <Col xs={12}>
              <AllocationsField />
            </Col>
          </Row>
        )}
      </FieldSection>
      <SectionHeader title={sectionLabel} />
      <FieldSection>
        <Row>
          <Col xs={12}>
            <p style={{ marginTop: 0 }}>
              {sectionDescription}
            </p>
            <TimesheetApproversField shouldIncludeAllTimesheetApprovers={true} />
          </Col>
        </Row>
      </FieldSection>
    </>
  );
}

export default BillingInformation;
